import React, { Component } from 'react';
import _ from 'lodash';
var DatePicker = require('react-bootstrap-date-picker');
import BooleanAlert from './BooleanAlert';
import Alert from './Alert';
var Api = require('./Config');
import moment from 'moment';

import { extendMoment } from 'moment-range';

const Moment = extendMoment(moment);
import JourneyDetail from './JourneyDetail';
import { saveAs } from './FileSaver';

class SingleRow extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var data = this.props.tcode;
    Moment.locale('en-us');
    var dt = Moment(data.journey_start_date);

    return (
      <tr>
        <td>{this.props.index}</td>

        <td>{data.t_code}</td>

        <td>{data.app_code}</td>
        <td>{data.username}</td>
        <td>{data.doctor_ref}</td>

        <td>{data.journey_name}</td>
        <td>{data.patient_ref}</td>
        <td>{dt.format('MM/DD/YY')}</td>
        <td>
          {data.survey_count}/{data.patient_message_count}
        </td>
        <td>
          {' '}
          <button
            onClick={() => {
              this.props.onDetail(data);
            }}
            className="btn btn-sm btn-primary"
          >
            {' '}
            detail{' '}
          </button>{' '}
        </td>
      </tr>
    );
  }
}

export default class DrillDownReport extends Component {
  err(err) {
    this.setState({ loading: false });
    console.log(err);
    // this.alert.open("Error",""+err);
  }

  constructor(props) {
    super(props);

    this.state = {
      dateRange: false,
      fromDate: new Date().toISOString(),
      tillDate: new Date().toISOString(),
      selectedApp: -1,
      selectedDoctor: -1,
      apps: [],
      doctors: [],
      tcodes: [],
      patients: [],
      selectedPatient: -1,
      journeys: [],
      selectedJourney: -1,
      indiDocs: [],
      selectedIndiDoctor: -1,
    };
    this.err = this.err.bind(this);
  }

  filter() {
    var data = this.orgiData;
    if (this.state.dateRange == true) {
      data = _.filter(data, (a) => {
        var startDate = Moment(this.state.fromDate.substring(0, 10));
        var endDate = Moment(this.state.tillDate.substring(0, 10));
        var range = Moment().range(startDate, endDate);
        return range.contains(Moment(a.journey_start_date.substring(0, 10)));
      });
    }

    if (this.state.selectedApp != -1) {
      data = _.filter(data, (a) => a.app_code == this.state.selectedApp);
      this.state.currentAppName = _.keyBy(this.state.apps, 'club_id')[this.state.selectedApp].clubname;
    }
    if (this.state.selectedDoctor != -1) {
      data = _.filter(data, (a) => a.doc_id == this.state.selectedDoctor);
      this.state.currentDoctorName = _.keyBy(this.state.doctors, 'id')[this.state.selectedDoctor].username;
    }
    if (this.state.selectedIndiDoctor != -1) {
      data = _.filter(data, (a) => a.doctor_ref == this.state.selectedIndiDoctor);
      this.state.currentIndiDoctor = _.keyBy(this.state.indiDocs, 'doctor_ref')[
        this.state.selectedIndiDoctor
      ].doctor_ref;
    }

    if (this.state.selectedPatient != -1) {
      data = _.filter(data, (a) => a.PID == this.state.selectedPatient);
      this.state.currentPatient = _.keyBy(this.state.patients, 'PID')[this.state.selectedPatient].patient_ref;
    }

    if (this.state.selectedJourney != -1) {
      data = _.filter(data, (a) => a.JID == this.state.selectedJourney);
    }
    this.setState({ tcodes: data });
    var appCount = _.uniq(_.map(data, 'app_code')).length;
    var doctorCount = _.uniq(_.map(data, 'username')).length;
    var patientCount = _.uniq(_.map(data, 'PID')).length;
    var indiDoctorCount = _.uniq(_.map(data, 'doctor_ref')).length;
    var tCodeCount = data.length;
    this.setState({ appCount, doctorCount, patientCount, tCodeCount, indiDoctorCount });
    var pt_message_count = 0;
    var pt_reply_count = 0;
    _.each(data, (dat) => {
      if (dat.patient_message_count) {
        pt_message_count += parseInt(dat.patient_message_count);
      }
      if (dat.survey_count) {
        pt_reply_count += parseInt(dat.survey_count);
      }
    });
    this.setState({ pt_message_count, pt_reply_count });
  }

  getSummeryText() {
    return (
      <table className="table table-striped" style={{ width: 300 }}>
        <tbody>
          {this.state.selectedApp == -1 && (
            <tr>
              <td>Active Apps</td>
              <td>{this.state.appCount}</td>
            </tr>
          )}
          {this.state.selectedApp != -1 && (
            <tr>
              <td style={currentSelected} colSpan={2}>
                {decodeURIComponent(this.state.currentAppName)}
              </td>
            </tr>
          )}

          {this.state.selectedDoctor == -1 && false && (
            <tr>
              <td>Active Providers Offices</td>
              <td>{this.state.doctorCount}</td>
            </tr>
          )}
          {this.state.selectedDoctor != -1 && false && (
            <tr>
              <td style={currentSelected} colSpan={2}>
                {this.state.currentDoctorName}
              </td>
            </tr>
          )}

          {this.state.selectedIndiDoctor == -1 && (
            <tr>
              <td>Drs. w/ active journeys</td>
              <td>{this.state.indiDoctorCount}</td>
            </tr>
          )}

          {this.state.selectedIndiDoctor != -1 && (
            <tr>
              <td style={currentSelected} colSpan={2}>
                {this.state.currentIndiDoctor}
              </td>
            </tr>
          )}

          {this.state.selectedPatient == -1 && (
            <tr>
              <td>Patients</td>
              <td>{this.state.patientCount}</td>
            </tr>
          )}

          {this.state.selectedPatient != -1 && (
            <tr>
              <td style={currentSelected} colSpan={2}>
                {this.state.currentPatient}
              </td>
            </tr>
          )}

          <tr>
            <td>T Code</td>
            <td colSpan={2}>{this.state.tCodeCount}</td>
          </tr>

          {false && (
            <tr>
              <td>Pt. messages sent</td>
              <td>{this.state.pt_message_count}</td>
            </tr>
          )}
          <tr>
            <td> # forms submitted</td>
            <td>{this.state.pt_reply_count}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  componentDidMount() {
    Api.dd_getAllClubs()
      .then((apps) => {
        this.setState({ apps });
      })
      .catch(this.err);
    Api.dd_getJourneyNames()
      .then((journeys) => {
        this.setState({ journeys });
      })
      .catch(this.err);
    this.getTCodes();
  }

  getAppsCombo() {
    return (
      <div className="form-group">
        {this.state.selectedApp != null && (
          <div>
            App Code <b> {this.state.selectedApp}</b> selected.
          </div>
        )}
      </div>
    );
  }

  getTCodes() {
    this.setState({
      selectedApp: -1,
      selectedDoctor: -1,
      selectedPatient: -1,
      dateRange: false,
      loading: true,
      tcodes: [],
    });

    Api.dd_getAllTCodes(1, 1)
      .then((p_tcodes) => {
        this.setState({ loading: false });
        this.allData = p_tcodes;
        this.initData(p_tcodes);
      })
      .catch(this.err);
  }

  initData(p_tcodes) {
    var tcodes = _.filter(p_tcodes, (single) => {
      if (!this.state.include_archived) {
        return single.deleted != 'Y';
      }
      return true;
    });

    _.remove(this.state.tcodes);

    this.orgiData = [];

    this.orgiData.push(...tcodes);

    this.state.tcodes.push(...tcodes);
    this.setState({ tcodes: this.state.tcodes });
    this.filter();
  }

  getFilterBar() {
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            <label>App </label>
            <select
              value={this.state.selectedApp}
              onChange={(e) => {
                this.state.selectedApp = e.target.value;
                this.state.selectedDoctor = -1;
                this.state.selectedPatient = -1;
                this.state.selectedIndiDoctor = -1;

                this.setState({
                  selectedApp: e.target.value,
                  selectedDoctor: -1,
                  selectedPatient: -1,
                  selectedIndiDoctor: -1,
                });
                this.filter();
                Api.dd_getDoctorByApp(e.target.value)
                  .then((doctors) => {
                    this.setState({ doctors });
                  })
                  .catch(this.err);
              }}
              style={form}
              className="form-control select"
            >
              <option value={-1}>All</option>
              {_.map(this.state.apps, (app, index) => {
                return (
                  <option key={index} value={app.club_id}>
                    {decodeURIComponent(app.clubname)}
                  </option>
                );
              })}
            </select>
          </div>

          <div>
            <label>Provider Office </label>
            <select
              style={form}
              value={this.state.selectedDoctor}
              onChange={(e) => {
                this.state.selectedDoctor = e.target.value;
                this.state.selectedIndiDoctor = -1;
                this.state.selectedPatient = -1;

                this.setState({ selectedDoctor: e.target.value, selectedIndiDoctor: -1 });

                this.filter();
                Api.dd_getIndiDoctorByDoc(e.target.value)
                  .then((data) => {
                    this.setState({ indiDocs: data });
                  })
                  .catch(this.err);
              }}
              className="form-control select"
            >
              <option value={-1}>All</option>
              {_.map(this.state.doctors, (doctor, index) => {
                return (
                  <option key={index} value={doctor.id}>
                    {doctor.username}
                  </option>
                );
              })}
            </select>
          </div>

          <div>
            <label>Provider</label>
            <select
              style={form}
              value={this.state.selectedIndiDoctor}
              onChange={(e) => {
                this.state.selectedIndiDoctor = e.target.value;
                this.state.selectedPatient = -1;

                this.setState({ selectedIndiDoctor: e.target.value, selectedPatient: -1 });

                this.filter();
                Api.dd_getPatientsForDoctor(e.target.value)
                  .then((data) => {
                    // var filtered=_.filter(data,(a)=>a.doctor_ref)

                    /*
                    filter here
                    */

                    this.setState({ patients: data });
                  })
                  .catch(this.err);
              }}
              className="form-control select"
            >
              <option value={-1}>All</option>
              {_.map(this.state.indiDocs, (doctor, index) => {
                return (
                  <option key={index} value={doctor.doctor_ref}>
                    {doctor.doctor_ref}
                  </option>
                );
              })}
            </select>
          </div>

          <div>
            <label>Patient </label>
            <select
              onChange={(e) => {
                this.state.selectedPatient = e.target.value;
                this.setState({ selectedPatient: e.target.value });
                this.filter();
              }}
              value={this.state.selectedPatient}
              style={form}
              className="form-control select"
            >
              <option value={-1}>All</option>
              {_.map(this.state.patients, (patient, index) => {
                return (
                  <option key={index} value={patient.PID}>
                    {patient.patient_ref}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <hr />
        <div>
          <label>Journey Name </label>
          <select
            onChange={(e) => {
              this.state.selectedJourney = e.target.value;
              this.setState({ selectedJourney: e.target.value });
              this.filter();
            }}
            value={this.state.selectedJourney}
            style={form}
            className="form-control select"
          >
            <option value={-1}>All</option>
            {_.map(this.state.journeys, (j, i) => {
              return (
                <option key={i} value={j.JID}>
                  {j.journey_name}
                </option>
              );
            })}
          </select>
        </div>

        <hr />
        <div style={{ display: 'flex' }}>
          <div>{this.getSummeryText()}</div>

          <div style={{ marginLeft: 140, display: 'flex' }}>
            <div className="form-check">
              <label className="form-check-label">
                <input
                  checked={this.state.include_archived}
                  onChange={(e) => {
                    this.state.include_archived = e.target.checked;
                    this.setState({ include_archived: this.state.include_archived });
                    this.initData(this.allData);

                    // this.getTCodes();
                  }}
                  type="checkbox"
                  style={{ margin: 5 }}
                  className="form-check-input"
                />
                Include Archived
              </label>
            </div>
            <div style={{ marginLeft: 120 }}>{this.getExportButton()}</div>
          </div>
        </div>
        <hr />
        <div className="text-center text-success font-weight-bold">
          <b> {this.state.tcodes.length} Journeys Found. </b>
        </div>
      </div>
    );
  }

  getDateChooser() {
    return (
      <div>
        <div>
          <button
            onClick={() => {
              this.getTCodes();
            }}
            className="btn btn-primary"
          >
            Refresh
          </button>
        </div>

        <div className="form-check">
          <label className="form-check-label">
            <input
              checked={this.state.dateRange}
              onChange={(e) => {
                this.state.dateRange = e.target.checked;
                this.setState({ dateRange: e.target.checked });
                this.filter();
              }}
              type="checkbox"
              style={{ margin: 5 }}
              className="form-check-input"
            />
            Date Range
          </label>
        </div>

        {this.state.dateRange == true && (
          <div style={{ display: 'flex', width: 400 }}>
            <div className="form-group">
              From Date{' '}
              <DatePicker
                value={this.state.fromDate}
                onChange={(e) => {
                  this.state.fromDate = e;
                  this.setState({ fromDate: e });
                  this.filter();
                }}
              />
            </div>
            <div style={{ width: 200 }}></div>
            <div className="form-group">
              Till Date{' '}
              <DatePicker
                value={this.state.tillDate}
                onChange={(e) => {
                  this.state.tillDate = e;
                  this.setState({ tillDate: e });
                  this.filter();
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  doSort(key) {
    var direction = 'asc';
    if (this.lastKey == key) {
      direction = 'desc';
      this.lastKey = null;
    } else {
      this.lastKey = key;
    }

    this.state.tcodes = _.orderBy(this.state.tcodes, [key], [direction]);
    this.setState({});
  }

  showTCodesArchived() {
    if (!this.state.include_archived) {
      return null;
    }

    if (this.state.loading) {
      return <div className="text-center">Loading....</div>;
    }

    var index = 1;

    return (
      <div>
        <div>
          <h3>Archived Journey</h3>
        </div>

        <div style={{ maxHeight: 600, overflowY: 'auto' }}>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th
                  style={sortable}
                  onClick={(e) => {
                    this.doSort('t_code');
                  }}
                >
                  T Code
                </th>
                <th
                  style={sortable}
                  onClick={(e) => {
                    this.doSort('app_code');
                  }}
                >
                  App Name
                </th>
                <th
                  style={sortable}
                  onClick={(e) => {
                    this.doSort('username');
                  }}
                >
                  Provider Office
                </th>
                <th
                  style={sortable}
                  onClick={(e) => {
                    this.doSort('doctor_ref');
                  }}
                >
                  Provider
                </th>
                <th
                  style={sortable}
                  onClick={(e) => {
                    this.doSort('journey_name');
                  }}
                >
                  Journey Name
                </th>
                <th
                  style={sortable}
                  onClick={(e) => {
                    this.doSort('patient_ref');
                  }}
                >
                  Patient
                </th>
                <th
                  style={sortable}
                  onClick={(e) => {
                    this.doSort('journey_start_date');
                  }}
                >
                  Start Date
                </th>
                <th
                  style={sortable}
                  onClick={(e) => {
                    this.doSort('survey_count');
                  }}
                >
                  Reply
                </th>

                <th>More</th>
              </tr>
            </thead>
            <tbody>
              {_.map(this.state.tcodes, (tcode, row) => {
                if (tcode.deleted == 'N') {
                  return null;
                }

                return (
                  <SingleRow
                    onDetail={(data) => {
                      this.setState({ journeyDetailVisible: true, currentData: data });
                    }}
                    tcode={tcode}
                    index={index++}
                    key={row}
                  />
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  showTCodesActive() {
    if (this.state.loading) {
      return <div className="text-center">Loading....</div>;
    }

    var index = 1;
    return (
      <div style={{ maxHeight: 600, overflowY: 'auto' }}>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th
                style={sortable}
                onClick={(e) => {
                  this.doSort('t_code');
                }}
              >
                T Code
              </th>
              <th
                style={sortable}
                onClick={(e) => {
                  this.doSort('app_code');
                }}
              >
                App Name
              </th>
              <th
                style={sortable}
                onClick={(e) => {
                  this.doSort('username');
                }}
              >
                Provider Office
              </th>
              <th
                style={sortable}
                onClick={(e) => {
                  this.doSort('doctor_ref');
                }}
              >
                Provider
              </th>
              <th
                style={sortable}
                onClick={(e) => {
                  this.doSort('journey_name');
                }}
              >
                Journey Name
              </th>
              <th
                style={sortable}
                onClick={(e) => {
                  this.doSort('patient_ref');
                }}
              >
                Patient
              </th>
              <th
                style={sortable}
                onClick={(e) => {
                  this.doSort('journey_start_date');
                }}
              >
                Start Date
              </th>
              <th
                style={sortable}
                onClick={(e) => {
                  this.doSort('survey_count');
                }}
              >
                Reply
              </th>

              <th>More</th>
            </tr>
          </thead>
          <tbody>
            {_.map(this.state.tcodes, (tcode, row) => {
              console.log('tcode.deleted', tcode.deleted);
              if (tcode.deleted == 'Y') {
                console.log('FUCK');
                return null;
              }

              return (
                <SingleRow
                  onDetail={(data) => {
                    this.setState({ journeyDetailVisible: true, currentData: data });
                  }}
                  tcode={tcode}
                  index={index++}
                  key={row}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  showJourneyDetail() {
    if (!this.state.journeyDetailVisible) {
      return;
    }

    return (
      <div className="modal show ">
        <div className="modal-dialog modal-lg " style={{ height: 1000, top: 40, width: window.innerWidth - 100 }}>
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                onClick={() => {
                  this.setState({ journeyDetailVisible: false });
                }}
                className="close"
                data-dismiss="modal"
              >
                &times;
              </button>
              <h4 className="modal-title">{this.state.currentData.patient_ref} </h4>
              <h5 className="modal-title">{this.state.currentData.t_code} </h5>
            </div>
            <div className="modal-body">
              <div style={{ marginTop: 10, maxHeight: 800, overflow: 'auto' }}>
                <JourneyDetail mode="report" t_code={this.state.currentData.t_code} />
              </div>
            </div>
            <div className="modal-footer">
              <button
                onClick={() => {
                  this.setState({ journeyDetailVisible: false });
                }}
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  getExportButton() {
    return (
      <button
        onClick={() => {
          /**
                 * 
                 * 
                 *  and 



T_Code, Archived, Journey Name, Journey start date, Patient ref, Patient initial, Doctor ref, App code,doctor_office name,replies
                 */
          var text =
            'T_Code, App Name, Office Name, Archived, Journey Name, Journey start date, Patient ref, Patient initial, Doctor ref,Forms  completed, Forms  total\r\n';
          _.each(this.state.tcodes, (single) => {
            var parts = single.patient_ref.split('-');
            var initial = parts[0];
            var patientref = initial.substring(initial.length - 2);
            var patientInitial = initial.substring(0, initial.length - 2);

            text += single.t_code + ',';
            text += single.app_code + ',';
            text += single.username + ',';
            text += (single.deleted != 'N' ? 'Archived' : 'Active') + ',';
            text += single.journey_name + ',';
            text += single.journey_start_date + ',';
            text += patientInitial + ',';
            text += patientref + ',';

            text += single.doctor_ref + ',';

            text += `${single.survey_count},`;
            text += `${single.patient_message_count}`;

            text += '\r\n';
          });

          var blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
          saveAs(blob, new Date() + '-report.csv');
        }}
        className="btn btn-info"
      >
        Export Data To CSV
      </button>
    );
  }

  render() {
    return (
      <div>
        <div>
          {this.getDateChooser()}
          {this.getFilterBar()}
          {this.showTCodesActive()}
          {this.showTCodesArchived()}
          {this.showJourneyDetail()}

          <br />
          <br />
          <br />
          <br />
        </div>
        <BooleanAlert
          ref={(ref) => {
            this.booleanAlert = ref;
          }}
        />
        <Alert
          ref={(a) => {
            this.alert = a;
          }}
        />
      </div>
    );
  }
}

const sortable = {
  cursor: 'pointer',
};

const currentSelected = {
  fontWeight: 'bold',
};

const form = {
  width: 250,
};
